module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_txt_m_jp.7f0857de0e9375190a0358ac3dae5c6e.png";